module.exports = __webpack_public_path__ + "static/media/emoji3.16eda7c0.svg";